import React from "react";
import {Row, Col, Container } from 'react-bootstrap';
import ReactMarkdown from "react-markdown"
import { GetURL } from "../common/site/functions";
import { Link } from "@StarberryUtils";


const ContentBlocks = (props) => {

  return (
      <div className="content-blocks news-card components--Static--content-blocks">
        <Container>
        {props.data.map((content, i) => {
			console.log("dfasdgsd", content.Content.includes("Career Videos"))
        let url = ''
		if(content.CTA_Link)
		{
			url = GetURL(content.CTA_Link.id)
		}
          return (
          		<Row className="block">
            		{i % 2 != 0 ? 
	          		<Col xs={12} md={6}>
	          			<img loading="lazy" src={content.Image.publicURL} alt="" />
	          		</Col> : ''}
	          		<Col xs={12} md={6} className={i % 2 != 0 ? 'two' : 'one'}>
	          			<ReactMarkdown source={content.Content} allowDangerousHtml />
						{content.CTA_Label && content.CTA_Link &&
	          			<Link to={`/${content.Content.includes("Career Videos") ? "news-and-guides/videos/career-videos/" : url}`} className="btn btn-success d-none d-md-inline-block btn-bg-transparent">{content.CTA_Label}</Link>
						}
	          		</Col>
	          		{i % 2 == 0 ? 
	          		<Col xs={12} md={6}>
						{content.Image &&
	          			<img loading="lazy" src={content.Image.publicURL} alt="" />
						}
	          		</Col> : ''}
          		</Row>
          )
        })}
        </Container>
      </div>
    )
}

export default ContentBlocks
